export const getNumberArraySum = (insuredSum: number[]) =>
  insuredSum.reduce((a, b) => a + b, 0)
